import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Icon, Tappable } from '@vectord/components';
import classNames from 'classnames';

import { setAddSuperBatchesModalState } from 'features/classCreation';
import styles from './AddSuperBatchesButton.module.scss';

export default function AddSuperBatchesButton({ disabled }) {
  const dispatch = useDispatch();

  const handleAddSuperBatches = useCallback(() => {
    dispatch(setAddSuperBatchesModalState(true));
  }, [dispatch]);

  return (
    <Tappable
      className={classNames('btn btn-outlined m-r-xs ', {
        'btn-primary': !disabled,
        [styles.addSuperBatchesButton]: disabled,
      })}
      onClick={handleAddSuperBatches}
      disabled={disabled}
    >
      <Icon
        name="plus-circle"
        className="m-r-xxs"
      />
      Add Batch/es
    </Tappable>
  );
}
